
import { Component, Vue, Prop } from "vue-property-decorator";
import { FormVorlageDto } from "@/dtos/formVorlageDto";

@Component
export default class FormTemplateDataTable extends Vue {
	@Prop()
	private templates!: FormVorlageDto[];
	private headers: any = [
		{
			text: "Id",
			width: "20px",
			sortable: false,
		},
		{
			text: "Tool Id",
			width: "20px",
			sortable: false,
		},
		{
			text: "Name",
			sortable: false,
		},
		{
			text: "Beschreibung",
			sortable: false,
		},
		{
			text: "Text",
			sortable: false,
		},
		{
			text: "Parameter",
			sortable: false,
		},
		{
			text: "Seite",
			sortable: false,
		},
		// Controls
		{
			text: "",
			sortable: false,
		},
	];

	private editTemplate(id: number) {
		this.$emit("editTemplate", id);
	}

	private deleteTemplate(id: number) {
		this.$emit("deleteTemplate", id);
	}

	private getVerformungsrichtung(template: FormVorlageDto) {
		if (
			template.parameters.filter(
				(p) => p.boostName === "Senkungsseite" || p.boostName === "Seite"
			).length > 0
		) {
			return template.parameters.filter(
				(p) => p.boostName === "Senkungsseite" || p.boostName === "Seite"
			)[0].value;
		} else {
			return "Neutral";
		}
	}
}
